import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../utils/layout-defaults';
import { parseMinMaxValue, parseValue } from '../utils/manager/price-manager';
import { Hint } from './hint';

const limit = 0.25;

function Price({
  data,
  index,
  //  options, isOptionsOptional,
  item,
  category,
}) {
  const { t } = useTranslation();
  const classes = useStyles(index);

  const minAndMax = useMemo(() => {
    const min =
      parseMinMaxValue(category, item, {
        bypassItemPrices: true,
        computeMin: true,
      }) + (data.value ?? 0);

    const max =
      parseMinMaxValue(category, item, {
        bypassItemPrices: true,
        computeMin: false,
      }) + (data.value ?? 0);

    // let min = data.value ?? 0;
    // let max = data.value ?? 0;

    // if (!_.isEmpty(options)) {
    //   const optionsMin = isOptionsOptional
    //     ? 0
    //     : _.min(options.map((o) => o.price?.value ?? 0)) ?? 0;
    //   min += optionsMin;

    //   const optionsMax = _.max(options.map((o) => o.price?.value ?? 0)) ?? 0;
    //   max += optionsMax;
    // }

    return { min, max, rate: (max - min) / max };
    // }, [data.value, isOptionsOptional, options]);
  }, [data.value]);

  return (
    <div className={classes.container}>
      <div className={classes.value}>
        <span className={classes.hint}>
          {minAndMax.rate > limit && t('price.from')}
        </span>
        <span
          className={
            !data.hint && minAndMax.rate <= limit
              ? classes.opacity
              : classes.lowOpacity
          }
        >
          {parseValue(minAndMax.min)}
        </span>
        {minAndMax.rate > 0 && minAndMax.rate <= limit && '+'}
      </div>
      {minAndMax.rate > limit && (
        <div className={classes.value}>
          <span className={classes.hint}>{t('price.to')}</span>
          <span
            className={
              !data.hint && minAndMax.rate <= limit
                ? classes.opacity
                : classes.lowOpacity
            }
          >
            {parseValue(minAndMax.max)}
          </span>
        </div>
      )}
      {data.hint !== item.hint && (
        <Hint className={classes.hint} value={data.hint} />
      )}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',

    marginTop: (index) => (index > 0 ? layoutDefaults.verticalMargin : 0),
    // border: '1px solid red',
  },
  value: {
    // fontSize: layoutDefaults.smallFontSize,
    // opacity: layoutDefaults.opacity,
    whiteSpace: 'nowrap',
  },
  opacity: {
    opacity: layoutDefaults.opacity,
  },
  lowOpacity: {
    opacity: 0.9,
  },
  hint: {
    opacity: layoutDefaults.opacity,
    fontSize: layoutDefaults.smallerFontSize,
  },
});

export { Price };
